import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { Link, NavLink, RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';
import {
    Collapse, DropdownItem, DropdownMenu,
    DropdownToggle,
    Nav,
    Navbar,
    NavbarBrand,
    NavbarToggler,
    NavItem,
    // NavLink,
    UncontrolledDropdown,
    Container
} from 'reactstrap';
import { lazyInject } from '@intelingu/core/IoC/container';
import { UserStore } from '@intelingu/core/stores/UserStore';
import withTranslation from "@intelingu/core/utils/withTranslation";
import {COMMON_NS} from "@intelingu/core/constants/base.constants";

const HeaderWrapper = styled.div`
  @media (min-width: 768px) {
      .nav-link {
        padding: 0.3rem 1rem;
        border-radius: 4px;  
      }
    
      .nav-link.signup {
        color: #fff !important;
        background: #599adb;
        border: 1px solid #fff;
        margin-left: 10px;
        
        &:hover {}
      }
      
      .nav-link.login {
        color: #000;
        background: #f5f8fa;
        border: 1px solid #eaedef;
      }  
  }
`;

export interface GuestHeaderProps extends RouteComponentProps<any> {
    t?;
    noRegisterButton?;
}

@withTranslation(COMMON_NS)
@observer export class GuestHeader extends Component<GuestHeaderProps, any> {

    @lazyInject(UserStore) userStore: UserStore;
    @observable isOpen = false;

    @action.bound toggle() {
        this.isOpen = !this.isOpen;
    }

    render() {
        const { match, t } = this.props;

        return <HeaderWrapper>
            <Navbar className={'profile navbar'} light expand="md" fixed={'top'}>
                <Container>
                    <NavbarBrand href="/">
                        <img
                            src={require('../../../../public/assets/images/logo.svg')}
                            alt={'intelingu'}
                            className={'logo-big'}
                            style={{ position: 'relative', top: -1 }}
                            width={112}
                        />

                        <img
                            src={require('../../../../public/assets/images/logo_icon.svg')}
                            alt={'intelingu'}
                            className={'logo-small'}
                            style={{ position: 'relative', top: -1 }}
                            width={26}
                        />
                    </NavbarBrand>
                    {/*<NavbarToggler onClick={this.toggle} />*/}

                    { !this.userStore.user && (
                        <>
                            <button className="menu-wrapper d-md-none" onClick={this.toggle}>
                                <div className={`hamburger-menu ${this.isOpen ? 'animate' : ''}`} />
                            </button>

                            <Collapse isOpen={this.isOpen} navbar>
                                <Nav className="ml-auto" navbar>
                                    <NavItem>
                                        <Link to={`/session/login`} className={'nav-link login'}>{ t('headerLogIn') }</Link>
                                    </NavItem>
                                    { !this.props.noRegisterButton && (
                                        <NavItem>
                                            <Link to={`${match.url}/register`} className={'nav-link signup'}>{ t('headerRegister') }</Link>
                                        </NavItem>
                                    ) }
                                </Nav>
                            </Collapse>
                        </>
                    )}
                </Container>
            </Navbar>
        </HeaderWrapper>
    }

}
